const durationFormatter = new Intl.NumberFormat("ro-RO", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export const formatDurationLabel = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const normalized = Number(value);
  if (!Number.isFinite(normalized) || normalized < 0) {
    return "—";
  }
  if (normalized < 1000) {
    return `${Math.round(normalized)} ms`;
  }
  if (normalized < 60000) {
    return `${durationFormatter.format(normalized / 1000)} s`;
  }
  return `${durationFormatter.format(normalized / 60000)} min`;
};

export const formatIntegerLabel = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const normalized = Number(value);
  if (!Number.isFinite(normalized)) {
    return "—";
  }
  return new Intl.NumberFormat("ro-RO").format(Math.round(normalized));
};

export const formatUsdLabel = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  const normalized = Number(value);
  if (!Number.isFinite(normalized)) {
    return "—";
  }
  return usdFormatter.format(normalized);
};

export const summarizeRunErrorMessage = (value, maxLength = 120) => {
  const normalized = String(value || "").trim();
  if (!normalized) {
    return null;
  }
  if (normalized.length <= maxLength) {
    return normalized;
  }
  return `${normalized.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
};
